var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLupa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "16px",
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#9AAAB4",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(16,16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,1c-2.48047,0 -4.5,2.01953 -4.5,4.5c0,1.05859 0.38281,2.02344 1,2.79297l-4.97656,4.97656l0.70313,0.71094l4.98047,-4.98047c0.76953,0.61719 1.73438,1 2.79297,1c2.48047,0 4.5,-2.01953 4.5,-4.5c0,-2.48047 -2.01953,-4.5 -4.5,-4.5zM10.5,2c1.9375,0 3.5,1.5625 3.5,3.5c0,1.9375 -1.5625,3.5 -3.5,3.5c-1.9375,0 -3.5,-1.5625 -3.5,-3.5c0,-1.9375 1.5625,-3.5 3.5,-3.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupa);
export default __webpack_public_path__ + "static/media/lupa.c261ac67930cd0794f734d21a258e4ec.svg";
export { ForwardRef as ReactComponent };